import React from 'react';
import dayjs from 'dayjs';
import Lottie from 'lottie-react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import NewRatnaIcon from '@/components/Icons/icons/NewRatnaIcon';

import confettiEffectAnimation from '../../../images/animations/confettiEffectAnimation.json';
import newRatnaImage from '../../../images/discovery/ratna.svg';
import { fetchUserProfileData, showBuyRatnaModal } from '../../../redux/user/userActions';
import { updateRatnaModalStatus } from '../../../services/user.service';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import ModalComponent from './ModalComponent';

export default function RatnaReplenishModal({ show, handleClose }) {
  const { userDetails } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleUserUpdate = async () => {
    if (userDetails?.upgradedAt) {
      const currentDate = dayjs(new Date());
      const userUpgradedAt = dayjs(userDetails?.upgradedAt);
      if (currentDate.diff(userUpgradedAt, 'day') < 30 && userDetails?.subscriptionStatus === 'active') {
        window.dataLayer.push({
          event: 'accountUpgraded',
        });
      }
    }
    const body = { showFreeCreditModal: { show: false, ratna: null } };
    const response = await updateRatnaModalStatus(body);
    if (response?.status) {
      dispatch(fetchUserProfileData());
    }
  };

  return (
    <ModalComponent
      show={show}
      onClose={() => {
        handleUserUpdate();
        handleClose();
      }}
      style={{ padding: '0px' }}
      bodyStyle={{ padding: '32px' }}
      width={444}
      outsideClickClose={false}
      topCross>
      <div className="warning-modal modal-main-content">
        <div className="ratna-modal-animation-container">
          <Lottie animationData={confettiEffectAnimation} loop={false} />
        </div>
        <div className="center">
          <NewRatnaIcon />
          <h2 style={{ marginTop: -13 }}>Ratna Replenished!</h2>
        </div>
        <div className="ratna-balance-div">
          <p className="text-sm text-default-n-900">Current Balance:</p>
          <img src={newRatnaImage} alt="ratna" />
          <h5>{userDetails?.balance}</h5>
        </div>
        <p style={{ fontSize: 14, padding: '0 14px' }}>
          We just refilled your balance of Ratna to {userDetails?.showFreeCreditModal?.ratna || 300}! We urge you to
          search and save {userDetails?.showFreeCreditModal?.ratna || 300} creators this month to take full advantage of
          this!
        </p>
        <br />
        <p style={{ fontSize: 14, padding: '0 14px' }}>
          You get {userDetails?.showFreeCreditModal?.ratna || 300} Ratna every month, your paid Ratna never expires. If
          you need more, buy more with any of our flexible plans!
        </p>
        <div className="extension-modal-footer-button-container" style={{ padding: '0' }}>
          <ButtonComponent
            onClick={() => {
              handleUserUpdate();
              navigate('/dashboard/discovery');
              handleClose();
            }}>
            Let&apos;s find creators!
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              handleUserUpdate();
              dispatch(showBuyRatnaModal('light'));
              handleClose();
            }}
            variant="secondary"
            style={{ marginTop: 16 }}>
            I need more!
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
}
